/* eslint-disable no-undef */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import template from "./ns-dialog.html";
import { events } from "@nuskin/ns-util";

/**
 *  This block should describe the overall uses, styling and purpose
 *  of this element.
 *  `ns-dialog` is a Nuskin element that does some stuff.
 *  There may be certain styling or other unique attributes that could be described here.
 *  You can also use markdown for things like:
 *  Lists
 * * `Great stuff`
 * * `awesome-sauce`
 * * `Other things`
 * * `And even more things`
 *
 *  Links
 *  http://developers.nuskin.com
 *
 *  Images
 *  ![alt text](https://www.nuskin.com/apps/hello/layouts/hello_global_landing/assets/ns-logo-new.svg "Title text")
 *
 *  and even code
 *  Some `inline-element` code
 *  ```javascript
 *  function(try) {
 *    console.log('me');
 *  }
 *  ```
 *
 *  and much more
 *  http://https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet
 *
 *  @demo demo/index.html Basic Demo
 */

class NsDialog extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "ns-dialog";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      offsetX: {
        type: Number,
        value: 0
      },
      offsetY: {
        type: Number,
        value: 0
      },
      /**
       * Indicates whether the dialog is currently open or not
       */
      opened: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      /**
       * Option for theming the dialog. Options include: light, dark (default)
       */
      theme: {
        type: String,
        value: "dark"
      }
    };
  }

  ready() {
    super.ready();
    events.subscribe("closeDialog", () => {
      this.close();
    });
    events.subscribe("openDialog", () => {
      this.open();
    });
    events.subscribe("toggleDialog", () => {
      this.toggle();
    });

    let marginTop = getComputedStyle(this.$.dialogBox).marginTop;
    let top = parseInt(marginTop.split("p")[0]) + this.offsetY;
    this.$.dialogBox.style.marginTop = top + "px";
  }

  /**
   * Display the dialog and prevent the background from scolling
   */
  open() {
    document.getElementsByTagName("html")[0].classList.add("no-scroll");
    this.opened = true;
  }

  /**
   * Hide the dialog and allow the page to scroll normally
   */
  close() {
    document.getElementsByTagName("html")[0].classList.remove("no-scroll");
    this.opened = false;
  }

  /**
   * toggle the display of the dialog
   */
  toggle() {
    this.opened ? this.close() : this.open();
  }
}
customElements.define(NsDialog.is, NsDialog);
